import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/shared/ui/card"
import Loader from '@/shared/components/Loader'
import { formatEntityUpdatedAt } from "@/shared/lib/dates"
import { isTemplateGenerating, isTemplateGenerationFailed } from "@/features/profile/templates/templateStatus"

export function TemplateList({ list, emptyKey, toolsById, onSelect }) {
  const { t, i18n } = useTranslation();

  if (!list.length) {
    return (
      <Card className="rounded-2xl">
        <CardContent className="p-6 text-sm text-[#71717a]">
          {t(emptyKey)}
        </CardContent>
      </Card>
    );
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {list.map((ut) => {
        const updatedAtLabel = formatEntityUpdatedAt(ut, i18n.language);
        const generating = isTemplateGenerating(ut);
        const failed = isTemplateGenerationFailed(ut);
        const isInteractive = !generating;
        return (
        <Card
          key={ut.id}
          className={`rounded-2xl shadow-none ${isInteractive ? "cursor-pointer hover:bg-muted/30" : "cursor-default"}`}
          onClick={isInteractive ? () => onSelect(ut.id) : undefined}
          role={isInteractive ? "button" : undefined}
          tabIndex={isInteractive ? 0 : undefined}
        >
          <CardContent className="p-4 items-center flex justify-between gap-3">
            <div className="min-w-0 flex-1 flex flex-col">
              <p className="font-semibold">{ut.name}</p>
              <p className="text-xs text-[#71717a]">
                {t("profile.templates.id", { id: ut.id })}
              </p>
              {generating ? (
                <p className="text-xs text-[#71717a]">
                  {t("profile.templates.status.generating")}
                </p>
              ) : failed ? (
                <p className="text-xs text-destructive">
                  {t("profile.templates.status.failed")}
                </p>
              ) : updatedAtLabel ? (
                <p className="text-xs text-[#71717a]" title={updatedAtLabel}>
                  {t("profile.templates.lastUpdated", { date: updatedAtLabel })}
                </p>
              ) : null}
              <p className="text-[13px] text-[#71717a] mt-[2px]">
                {toolsById.get(ut.tool_id)?.name || "-"}
              </p>
            </div>
            {generating ? <Loader /> : null}
          </CardContent>
        </Card>
        );
      })}
    </div>
  );
}
